import { Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useMemo, useState } from "react";
import GoogleModal from "./GoogleModal";

interface GoogleButtonProps {
  coordinate?: [number, number];
}

const GoogleButton = ({ coordinate }: GoogleButtonProps) => {
  const [openModal, setOpenModal] = useState(false);

  const disabled = useMemo(
    () =>
      !coordinate || Number.isNaN(coordinate[0]) || Number.isNaN(coordinate[1]),
    [coordinate]
  );

  return (
    <>
      <Fab
        onClick={() => setOpenModal(true)}
        disabled={disabled}
        sx={{
          backgroundColor: "#f36d45",
          ":hover": {
            backgroundColor: "#f36d45",
            opacity: 0.9,
            transition: "opacity 0.3s",
            scale: "1.05",
          },
          color: "white",
          position: "fixed",
          right: "calc(env(safe-area-inset-right, 0px) + 16px)",
          bottom: "calc(env(safe-area-inset-bottom, 0px) + 16px)",
          zIndex: 5000,
        }}
      >
        <AddIcon />
      </Fab>

      {coordinate && (
        <GoogleModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          coordinate={coordinate}
        />
      )}
    </>
  );
};

export default GoogleButton;
